import { InputLabel } from '@mui/material'
import { styled } from '@mui/material/styles'

import { HeaderProps } from '#/components/FormCall/Inputs/InputImage/types'

const Label = styled(InputLabel)({
  position: 'static',
  transform: 'none',
})

export const Header = ({ error, label, required }: HeaderProps) => (
  <Label shrink required={required} error={Boolean(error)}>
    {label}
  </Label>
)
